// Pure helpers for FlowsPage.jsx's FlowToggleConfirmDialog — extracted so
// the copy-selection and updateFlowAutomate payload-building logic is
// unit-testable with node:test without any React/JSX machinery. The actual
// dialog open/cancel/confirm wiring lives in FlowsPage.jsx itself and is
// verified manually (no React component-test harness in this package yet).

// Copy differs by direction: turning ON warns that this immediately
// auto-executes any already-pending suggestions for this flow (the backend's
// PATCH /:flowKey route does a retroactive sweep via runAutomatedSuggestion()
// for every pending suggestion matching this flow key, with real TRQ/eBay
// writes) — turning OFF needs no such caveat, since that sweep never runs.
export function flowToggleCopy(targetAutomate) {
  return targetAutomate
    ? {
        title: 'Automate this flow?',
        confirmLabel: 'Automate',
        confirmColor: 'warning',
        warnsRetroactiveSweep: true,
      }
    : {
        title: 'Require human approval for this flow?',
        confirmLabel: 'Require Approval',
        confirmColor: 'primary',
        warnsRetroactiveSweep: false,
      }
}

// The exact payload updateFlowAutomate() is called with on confirm — same
// shape the Switch's onChange used to build directly before this
// confirmation step was added. company/channel/client come from the flow
// itself (flows are scoped per (flowKey, company, channel, client) — see
// migration 0030_flow_company_channel.sql / 0050_flows_spam_rules_client.sql),
// not user input.
export function buildFlowAutomatePayload(flow, note) {
  // team (2026-10-07): the row is keyed on it too.
  return { company: flow.company, channel: flow.channel, client: flow.client, ...(flow.team ? { team: flow.team } : {}), automate: !flow.automate, note: note.trim() || undefined }
}
